import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { CurrencyConversionExchangeRatesProfile } from 'lumen/models';
import type MarketSettingsCurrencyConversionProfileRoute from 'lumen/routes/market/settings/currency-conversion/profile';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsCurrencyConversionProfileController extends Controller {
  declare model: ModelFrom<MarketSettingsCurrencyConversionProfileRoute>;

  @service declare access: Services['access'];

  @tracked private _hasDiscardedChanges = false;

  get exchangeRatesProfile(): CurrencyConversionExchangeRatesProfile | null {
    return this.model.exchangeRatesProfile.last?.value ?? null;
  }

  get isReadOnly(): boolean {
    return !this.access.hasCurrencyConversionEditAccess;
  }

  get showMissingCurrencyAlert(): boolean {
    if (this._hasDiscardedChanges) {
      return false;
    }
    return this.exchangeRatesProfile?.hasNoExchangeRates ?? false;
  }

  get showMissingPortfolioCurrenciesAlert(): boolean {
    if (this._hasDiscardedChanges) {
      return false;
    }
    return this.exchangeRatesProfile?.isMissingPortfolioCurrencies ?? false;
  }

  resetDiscardedChanges(): void {
    this._hasDiscardedChanges = false;
  }

  @action
  discardUnsavedChanges(): void {
    this._hasDiscardedChanges = true;
    this.exchangeRatesProfile?.rollbackAttributes();
    this.exchangeRatesProfile?.rates.forEach((rate) =>
      rate.rollbackAttributes(),
    );
  }
}
